/* eslint-disable */
import { IconPoint, IconNotes, IconUserCircle, IconTicket } from "@tabler/icons-react";
import { uniqueId } from "lodash";
import { Dashboard, DeviceHub, Insights, ListAlt } from "@mui/icons-material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { OneDotSvg } from "../../../common/utils";
export const MenudataUser = [
  {
    id: uniqueId(),
    title: "Projects",
    icon: AccountTreeIcon,
    href: "/projects",
    children: [
      {
        id: uniqueId(),
        title: "Discover",
        icon: IconPoint,
        href: "/",
        children: [
          
          {
            id: uniqueId(),
            title: "Overview",
            icon: OneDotSvg,
            href: "/",
          },
          {
            id: uniqueId(),
            title: "Report",
            icon: OneDotSvg,
            href: "/",
          },
        ],
      },
    ],
  },

  {
    id: uniqueId(),
    title: "Dashboard",
    icon: Dashboard,
    href: "/dashboard?menu=dashboard",
  },
  // {
  //   id: uniqueId(),
  //   title: "Organisation",
  //   icon: DeviceHub,
  //   href: "/organisationsdashboard",
  // },
  {
    id: uniqueId(),
    title: "WebSite List",
    icon: ListAlt,
    href: "/websitelist",
  },
  {
    id: uniqueId(),
    title: "Website Analyzing",
    icon: Insights,
    href: "/website",
  },
  {
    id: uniqueId(),
    title: "Account Settings",
    icon: IconUserCircle,
    href: "/account-settings",
  },
  {
    id: uniqueId(),
    title: "Notes",
    icon: IconNotes,
    href: "/notes",
  },
  {
    id: uniqueId(),
    title: "App-Integration",
    icon: IconNotes,
    href: "/app-integration",
  },
  // {
  //   id: uniqueId(),
  //   title: "Support",
  //   icon: IconTicket,
  //   href: "/support",
  // },
];
export const MenudataAdmin = [
  {
    id: uniqueId(),
    title: "Projects",
    icon: AccountTreeIcon,
    href: "/",
    children: [
      {
        id: uniqueId(),
        title: "Discover",
        icon: IconPoint,
        href: "/",
        children: [
          {
            id: uniqueId(),
            title: "Overview",
            icon: IconPoint,
            href: "/",
          },
          {
            id: uniqueId(),
            title: "Report",
            icon: IconPoint,
            href: "/",
          },
        ],
      },
    ],
  },

  {
    id: uniqueId(),
    title: "Dashboard",
    icon: Dashboard,
    href: "/dashboard?menu=dashboard",
  },
  // {
  //   id: uniqueId(),
  //   title: "Organisation",
  //   icon: DeviceHub,
  //   href: "/organisationsdashboard",
  // },
  {
    id: uniqueId(),
    title: "WebSite List",
    icon: ListAlt,
    href: "/websitelist",
  },
  {
    id: uniqueId(),
    title: "Website Analyzing",
    icon: Insights,
    href: "/website",
  },
  {
    id: uniqueId(),
    title: "Account Settings",
    icon: IconUserCircle,
    href: "/account-settings",
  },
  {
    id: uniqueId(),
    title: "Notes",
    icon: IconNotes,
    href: "/notes",
  },
  {
    id: uniqueId(),
    title: "App-Integration",
    icon: IconNotes,
    href: "/app-integration",
  },
  // {
  //   id: uniqueId(),
  //   title: "Support",
  //   icon: SupervisorAccountIcon,
  //   href: "/tickets",
  // },
];
